import { InstallAppPrompt } from '@/components/pwa/InstallAppPrompt'
import { BIDDLE_APP_STORE_URL } from '@/lib/campaign'
import { isAndroidDevice, isIOSDevice, isStandaloneDisplay } from '@/lib/pwa'

/**
 * Post-claim install CTA for the letter landing:
 * - iOS → official App Store badge image
 * - Android → add-to-home-screen / install prompt
 * - Desktop web → nothing
 */
export function LetterClaimInstallCta() {
  if (typeof navigator === 'undefined' || isStandaloneDisplay()) return null

  if (isIOSDevice()) {
    return (
      <div className="flex justify-center pt-1">
        <a
          href={BIDDLE_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download Biddle on the App Store"
          className="inline-block transition-transform hover:scale-105 active:scale-95"
        >
          <img
            src="/download-on-the-app-store.svg"
            alt="Download on the App Store"
            className="h-12 w-auto sm:h-14"
            draggable={false}
          />
        </a>
      </div>
    )
  }

  if (isAndroidDevice()) {
    return <InstallAppPrompt force compact />
  }

  return null
}
